import React, { useEffect, useState, useContext } from "react";
import ReactPaginate from 'react-paginate';
import PageTitle from '../../../jsx/layouts/PageTitle';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import { useNavigate } from "react-router-dom";
import DistrictFilter from '../districtFilter/DistrictFilter';
import { LocationContext } from '../../../context/LocationContext';
import { getEditProfileList } from "../../../services/adminApiService/editProfileApi/editProfileApis";



const statusStyles = {
  Approved: {
    background: '#E7F9EF',
    color: '#52C41A',
    borderRadius: 12,
    padding: '4px 18px',
    fontWeight: 500,
    fontSize: 16,
    display: 'inline-block',
    border: '1px solid #B7E4C7',
    boxShadow: '0px 1px 2px rgba(82,196,26,0.08)',
    fontFamily: 'inherit',
    letterSpacing: '0.01em',
  },
  Pending: { background: '#FFF7E0', color: '#FAAD14', borderRadius: 12, padding: '4px 18px', fontWeight: 500, fontSize: 16, display: 'inline-block' },
  Rejected: { background: '#FFE0E0', color: '#FF4D4F', borderRadius: 12, padding: '4px 18px', fontWeight: 500, fontSize: 16, display: 'inline-block' },
  Review: { background: '#F3F0FF', color: '#B18AFF', borderRadius: 12, padding: '4px 18px', fontWeight: 500, fontSize: 16, display: 'inline-block' },
};

const EditProfileRequestList = () => {
  const [searchValue, setSearchValue] = useState("");
  // block was unused; use selectedDistrictId from LocationContext instead
  const { selectedDistrictId } = useContext(LocationContext);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [editProfileList, setEditProfileList] = useState([]);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const handlePageChange = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // API expects: number (per page), page, search, city (district), status
        const response = await getEditProfileList(perPage, currentPage, searchValue, selectedDistrictId, status);
        setEditProfileList(response.data.data.data || []);
        setTotal(response.data.data.total || 0);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log("Error in fetching edit profile request list:", err);
      }
    };
    fetchData();
  }, [currentPage, perPage, searchValue, selectedDistrictId, status]);


  return (
    <>
      <PageTitle
        activeMenu="Edit Profile Request List"
        motherMenu="Edit Profile Request"
      />
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        <h2 >Edit Profile Request List</h2>
        {/* Filter Bar */}

        <div className="row g-2 mb-4">
          <div className="col-12 col-md-auto">
            <FilterNumber value={perPage} onChange={(val) => { setPerPage(val); setCurrentPage(1); }} />
          </div>
          <div className="col-8 col-md ">
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                placeholder="Search Here"
                value={searchValue}
                onChange={e => { setSearchValue(e.target.value); setCurrentPage(1); }}
                className="form-control"
                style={{ padding: '10px 40px 10px 16px', borderRadius: 8, fontSize: 16 }}
              />
              <span style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', color: '#888' }}>
                <i className="fa fa-search" />
              </span>
            </div>
          </div>
          <div className="col-12 col-md-auto">
            {(() => {
              const loginDetails = localStorage.getItem('login_Details');
              let userLevel = null;
              try {
                if (loginDetails) {
                  const parsedDetails = JSON.parse(loginDetails);
                  userLevel = parsedDetails?.user?.user_level;
                }
              } catch (error) {
                console.error("Error parsing login_Details:", error);
              }
              return userLevel === 2 ? <DistrictFilter setCurrentPage={setCurrentPage}/> : null;
            })()}
          </div>
       
          <div className=" col-md-auto">
            <select value={status} onChange={e => { setStatus(e.target.value); setCurrentPage(1); }} className="form-select" style={{ width: "100%", padding: "11px 50px 10px 11px" }}>
              <option value="">Status</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>
        </div>
        {/* Add your table and UI below this filter bar */}
        <div className="card-body">
          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>

          ) : (

            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                <form>
                  <table id="example" className="display w-100 dataTable">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Applied Date</th>
                        <th>District</th>
                        {/* <th>Block</th> */}
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      {editProfileList?.length > 0 ? (
                        editProfileList.map((data, idx) => {
                          return (
                            <tr key={idx}>
                              <td style={{ padding: '12px 8px', fontSize: 17 }}>
                                <div style={{ fontWeight: 500 }}>{data?.name_of_legel_entity || data?.user_name || data?.first_name + (data?.last_name ? ' ' + data?.last_name : '') || 'NA'}</div>
                                <div style={{ color: '#9CA3AF', fontSize: 12, fontWeight: 400 }}>{data?.email || 'NA'}</div>
                              </td>
                              <td style={{ color: '#000413', fontSize: 14, fontWeight: 400 }}>{data?.sub_category_name || 'NA'}</td>
                              <td style={{ color: '#000413', fontSize: 14, fontWeight: 400 }}>{data?.applite_date || 'NA'}</td>
                              <td style={{ color: '#000413', fontSize: 14, fontWeight: 400 }}>{data?.district_name || 'NA'}</td>
                              {/* <td style={{ color: '#000413', fontSize: 14, fontWeight: 400 }}>{data?.city}</td> */}
                              <td style={{ padding: '12px 8px', fontSize: 14 }}>
                                <span style={statusStyles[(data.status || '').charAt(0).toUpperCase() + (data.status || '').slice(1)]}>
                                  {data.status || 'NA'}
                                </span>
                              </td>
                              <td>
                                <i className="fa fa-eye" style={{ cursor: 'pointer', color: '#888', fontSize: 18 }} onClick={() => navigate(`/edit-profile-request-view/${data.edit_profile_id}`)} />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">Data is not available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
      <ReactPaginate
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={8}
        marginPagesDisplayed={2}
        pageCount={Math.ceil(total / perPage)}
        previousLabel="< previous"
        pageClassName="page-item mx-1 my-1"
        pageLinkClassName="page-link"
        previousClassName="page-item mx-1 my-1"
        previousLinkClassName="page-link"
        nextClassName="page-item mx-1 my-1"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item mx-1 my-1"
        breakLinkClassName="page-link"
        containerClassName="pagination d-flex flex-wrap "
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />
    </>

  );
};

export default EditProfileRequestList;
